module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/modules/_library.js
// module id = 66
// module chunks = 20